
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Table from '../../../../components/Common/Table';
import TableNoRecords from '../../../../components/Common/Table/TableNoRecords';
import Pagination from '../../../../components/Pagination';
import { Context } from '../../../../config/store';
import LenderUgroService from '../../../../services/lender';
import FundOutModal from './FoundoutModal';
import tableColumns from './tableColum';
import './style.css'
// import moment from 'moment'	

const FundOut = ({ selectedLender, leadInfo, lafNumber }) => {
  const { state } = useContext(Context);
  const leadId = useParams().id;
  const queryId = useParams().queryId;
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [companyData, setCompanyData] = useState({});
  const [page, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [isBtCase, setIsBtCase] = useState(false)

  const fundoutList = async () => {
    setLoading(true);
    let response = await LenderUgroService.getFundoutDetail({
      lender_id: selectedLender,
      type: state.userType,
      subType: state.userType === 'admin' ? 'co-lender' : '',
      leadId: leadId,
    });
    setIsBtCase(response?.data?.data?.is_bt_case)
    setCompanyData(response?.data?.data?.lead_detail);
    setTableData(response?.data?.data?.lead_fundout_detail);
    setLoading(false);
    setCurrentPage(page);
    setPagination(response?.data?.data?.cl_leads?.pagination);
  };

  const [modalState, setModalState] = useState(false);

  const toggleModal = () => {
    setModalState(!modalState);
  };

  useLayoutEffect(() => {
    fundoutList();
  }, [page, selectedLender, location.pathname]);

  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };
  return (
    <div>
      <div className='row no-gutters justify-content-between align-items-center'>
        <div></div>
        <div className='mb-2'>
          {checkHasPermission('add-fundout') && [6,9,10,18,19,20].includes(leadInfo?.cl_lead_lender_status) && <button className='btn btn-custom' onClick={toggleModal}>
            Add UTR
          </button>}
          {modalState && (
            <FundOutModal
              userType={state.userType}
              state={modalState}
              toggleModal={toggleModal}
              leadId={leadId}
              lenderId={selectedLender}
              reloadTable={fundoutList}
              selectedLender={selectedLender}
              lafNumber={lafNumber}
              companyData={companyData}
              isBtCase={isBtCase}
            />
          )}
        </div>
      </div>
      <div className='fund_out_table'>
        <Table
          checkbox={false}
          columns={tableColumns}
          rows={tableData}
          loading={loading}
          reloadTable={fundoutList}
          leadInfo={leadInfo}
        >
          {Boolean(!tableData.length && !loading) && <TableNoRecords />}
        </Table>
      </div>
      <div className="my-2">
        {pagination?.total_pages ? (
          <Pagination
            setPage={setCurrentPage}
            total_pages={pagination.total_pages}
            total={pagination.total}
            showTotal={true}
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default FundOut;
